<div class="cookies">
  <div class="cookies__link">{{ 't.we-use' | translate }} <a (click)="$event.preventDefault(); goToPolicy()" href="/cookie-policy">{{ 'link.cookies' | translate }}</a>.</div>
  <button class="cookies__accept" (click)="cookiesAccepted()" title="{{ 'btn.accept' | translate }}">{{ 'btn.accept' | translate }}</button>
</div>
@if (au?.text$ | async; as data) {
  <div class="au-payment" [innerHTML]="data"></div>
}


